const routes = {
  report: {
    onoff: {
      name: "OnOff Report",
      route: "../on-off-report",
    },
    efficiency: {
      name: "Efficiency Report",
      route: "../efficiency-report",
    },
    production: {
      name: "Production Report",
      route: "../production-report",
    },
  },
  jobmapping: {
    name: "Job Mappings",
    route: "../job-schedules",
  },
  shift: {
    viewAll: {
      name: "View All Shifts",
      route: "../shifts",
    },
    add: {
      name: "Add Shifts",
      route: "../shifts/0",
    },
  },
  dashboard: {
    name: "Dashboard",
    route: "../dashboard",
  },
};
const searchStructure = [
  {
    keys: "reports",
    matchedRoutes: Object.values(routes.report),
    childRoutes: [
      {
        keys: "onoff|report onoff|onoff report",
        matchedRoutes: [routes.report.onoff],
      },
      {
        keys: "efficiency|report efficiency|report efficiency",
        matchedRoutes: [routes.report.efficiency],
      },
      {
        keys: "production|report production|production report",
        matchedRoutes: [routes.report.production],
      },
    ],
  },
  {
    keys: "dashboard",
    matchedRoutes: [routes.dashboard],
    childRoutes: [],
  },
  {
    keys: "job mappings|mappings|jobs",
    matchedRoutes: [routes.jobmapping],
    childRoutes: [],
  },
  {
    keys: "shifts",
    matchedRoutes: Object.values(routes.shift),
    childRoutes: [
      {
        keys: "shift add|add shift",
        matchedRoutes: [routes.report.onoff],
      },
      {
        keys: "shift view|view shift",
        matchedRoutes: [routes.report.onoff],
      },
    ],
  },
];

export default searchStructure;
